import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const user = await login(form.email, form.password);
      toast.success(`Welcome, ${user.name}`);
      navigate(user.role === 'admin' ? '/admin' : '/');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] flex items-center bg-[#F8F9FA] py-16">
      <div className="max-w-md mx-auto px-6 w-full">
        <div className="card-tactile p-8">
          <div className="text-center mb-6">
            <img src="https://customer-assets-lqy194kg.emergentagent.net/job_first-ej/artifacts/mmnl3841_WIFI%20WEB%20LOGO.webp" alt="Wisconsin First seal" className="w-16 h-16 mx-auto object-contain" />
            <h1 className="font-serif text-3xl text-royal font-bold mt-4">Member Sign In</h1>
            <p className="text-charcoal-muted text-sm mt-2">Access your account, prayer portal, and department resources.</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-royal mb-1">Email</label>
              <input data-testid="login-email" required type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-royal/40" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-royal mb-1">Password</label>
              <input data-testid="login-password" required type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-royal/40" />
            </div>
            <button data-testid="login-submit-btn" disabled={busy} type="submit" className="btn-royal w-full justify-center">{busy ? 'Signing in...' : 'Sign In'}</button>
          </form>
          <div className="flex items-center gap-3 my-6"><div className="flex-1 h-px bg-gray-200" /><span className="text-xs text-charcoal-muted">or</span><div className="flex-1 h-px bg-gray-200" /></div>
          <button data-testid="google-signin-btn" onClick={googleLogin} className="w-full py-3 rounded-full border border-gray-200 hover:border-royal transition flex items-center justify-center gap-2 text-royal font-semibold">
            <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Continue with Google
          </button>
          <div className="text-center text-sm text-charcoal-muted mt-6">
            No account? <Link to="/register" className="text-royal font-semibold hover:text-gold">Register</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
